import type * as Api from 'src/api'

/** The backend sends both raw names here (they fill the edit form), so the locale picks one; English falls back to Georgian. */
export function templateName(template: Api.AdministratorStatementTemplate, locale: Api.LanguageString): string {
  return locale === 'en' && template.titleEn != null && template.titleEn !== '' ? template.titleEn : template.title
}
